module.exports = __webpack_public_path__ + "img/car-stopped.8567e93c.svg";